import { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import "../style/Changepassword.css";
import { apiAxios } from "../utils/apiAxios";
import { toast } from "react-toastify";
const ChangePassword = () => {

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[^\s]{6,14}$/;
  const [newPasswordError, setNewPasswordError] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);



  const validatePassword = (pwd: string) => {
    return PASSWORD_REGEX.test(pwd)
      ? ""
      : "Password must include uppercase, lowercase, digit, special character and no spaces.";
  };

  const handleChangePassword = async () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error("All fields are required");
      return;
    }
    if (currentPassword === newPassword) {
  toast.error("New password must be different from current password");
  return;
}
    const pwdError = validatePassword(newPassword);
    if (pwdError) {
      setNewPasswordError(pwdError);
      return;
    } else {
      setNewPasswordError("");
    }

    if (newPassword !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
      toast.error("Password does not match");
      return;
    } else {
      setConfirmPasswordError("");
    }

    try {
      const res = await apiAxios.post("/Auth/ChangePassword", {
        currentPassword,
        newPassword,
      });

      if (res.data?.isSuccess) {
        toast.success(res.data.singleData || "Password updated");

        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setNewPasswordError("");
        setConfirmPasswordError("");

      } else {
        toast.error(res.data?.errors?.[0] || "Failed to update password");
      }

    } catch (err: any) {
      console.error("Change password error:", err);

      toast.error(
        err?.response?.data?.errors?.[0] ||
        err?.response?.data?.singleData ||
        "Something went wrong"
      );
    }
  };
  return (
    <div>

      <h4 className="mb-4">Change Password</h4>

      <div className="premium-card p-4 ">

        <Row>

          {/* CURRENT PASSWORD */}
          <Col md={4} className="mb-4">
            <label className="form-label">Current Password</label>

            <div className="password-field">
              <i className="bi bi-lock input-icon"></i>

              <Form.Control
                type={showCurrent ? "text" : "password"}
                placeholder="Enter Current Password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="rounded-3 py-2"
              />

              <i
                className={`bi ${showCurrent ? "bi-eye" : "bi-eye-slash"} toggle-icon`}
                onClick={() => setShowCurrent(!showCurrent)}
              ></i>
            </div>
          </Col>

          {/* NEW PASSWORD */}
          <Col md={4} className="mb-4 position-relative">
            <label className="form-label">New Password</label>

            <div className="password-field ">
              <i className="bi bi-key input-icon"></i>

              <Form.Control
                type={showNew ? "text" : "password"}
                placeholder="Enter New Password"
                value={newPassword}
                onChange={(e) => {
                  const value = e.target.value;
                  setNewPassword(value);

                  const error = validatePassword(value);
                  setNewPasswordError(error);
                }}
                className="rounded-3 py-2"
              />

              <i
                className={`bi ${showNew ? "bi-eye" : "bi-eye-slash"} toggle-icon`}
                onClick={() => setShowNew(!showNew)}
              ></i>


              {showNew && (
                <div className="password-tooltip">
                  Password must have at least one digit, one lowercase, one uppercase, one special character. 8–14 characters. No spaces.
                </div>
              )}

              {/* ✅ ERROR */}
              {newPasswordError && (
                <small className="text-danger">{newPasswordError}</small>
              )}
            </div>
          </Col>

          {/* CONFIRM PASSWORD */}
          <Col md={4} className="mb-4">
            <label className="form-label">Confirm Password</label>

            <div className="password-field">
              <i className="bi bi-shield-lock input-icon"></i>

              <Form.Control
                type={showConfirm ? "text" : "password"}
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => {
                  const value = e.target.value;
                  setConfirmPassword(value);

                  if (newPassword !== value) {
                    setConfirmPasswordError("Passwords do not match");
                  } else {
                    setConfirmPasswordError("");
                  }
                }}
                className="rounded-3 py-2"
              />

              <i
                className={`bi ${showConfirm ? "bi-eye" : "bi-eye-slash"} toggle-icon`}
                onClick={() => setShowConfirm(!showConfirm)}
              ></i>
            </div>

            {confirmPasswordError && (
              <small className="text-danger">{confirmPasswordError}</small>
            )}
          </Col>
          <Col md={12}>
               <div className="text-start mt-3">
          <button
            className="btn btn-primary px-4 py-2"
            onClick={handleChangePassword}
          >
            Update Password
          </button>
        </div>
          </Col>

        </Row>

   

      </div>

    </div>
  );
};

export default ChangePassword;